import React, {useEffect, useState} from 'react';
import style from "../task-creator.module.css";
import {ru} from "../../../data/ru";
import {by} from "../../../data/by";

const Type = ({changeType, defaultType}) => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;

    const [typeId, setTypeId] = useState('')
    function changeHandler(e) {
        setTypeId(e.target.value)
    }
    useEffect(() => {
        changeType(typeId)
    }, [typeId])
    return (
        <>
            <h2>{language.createTaskType}:</h2>

            <select className={style.task_select_type}  value={typeId?typeId:defaultType} disabled={defaultType} onChange={(e) => changeHandler(e)}>
                {typeId===''&& <option> {language.chooseTypeQuestion}</option>}
                <option value={'1'} >{language.choiceOfOneOption}</option>
                <option value={'2'} >{language.multipleChoice}</option>
                <option value={'3'} >{language.longAnswer}</option>
                <option value={'4'} >{language.shortAnswer}</option>
                <option value={'5'} >{language.associations}</option>
                <option value={'6'} >{language.omissionsInTheText}</option>
                <option value={'7'} >{language.sequencing}</option>
                <option value={'8'} >{language.withExplanation}</option>
                <option value={'9'} >{language.transfer}</option>
                <option value={'10'} >{language.table}</option>
                <option value={'11'} >{language.variety}</option>

            </select>
        </>
    );
};

export default Type;